import React, { ReactElement } from 'react';
import { useRouter } from 'next/router';
import Link from 'next/link';
import { classNames } from 'lib/util';

const menuItems = [
  { title: 'Transcripts', href: '/transcripts' },
  { title: 'Account', href: '/account' },
  { title: 'How to Transcribe', href: '/how-to-transcribe' },
];

export function NavBarMenu(): ReactElement {
  const router = useRouter();

  return (
    <div className="ml-10 flex items-baseline space-x-4">
      {menuItems.map((item) => (
        <Link key={item.href} href={item.href}>
          <a
            className={classNames(
              'font-medium text-gray-500 hover:text-gray-900',
              router.asPath === item.href && 'border-b-2 border-blue-500'
            )}
          >
            {item.title}
          </a>
        </Link>
      ))}
    </div>
  );
}

export function NavBarMenuMobile(): ReactElement {
  const router = useRouter();

  return (
    <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
      {menuItems.map((item) => (
        <Link key={item.href} href={item.href}>
          <a
            className={classNames(
              'block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50',
              router.asPath === item.href && 'bg-blue-100'
            )}
          >
            {item.title}
          </a>
        </Link>
      ))}
    </div>
  );
}
